import { useContext } from 'react';
import { AppContext, AppContextValue } from './AppContext';

export const useAppContext = (): AppContextValue => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
